module.exports = __webpack_public_path__ + "img/jiazhuangbanner.d161a298.jpg";